import { useEffect, useMemo, useRef, useState } from "react";
import Field from "../../../../../vendors/components/Field";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import ToastService from "../../../../../vendors/services/toastService";
import { Divider } from "primereact/divider";
import EventoService from "../../../../services/evento.service";
import DocumentosController from "../controller/documentos.controller";
import EventoVisualizarController from "../controller/evento-visualizar.controller";
import { formatDate } from "../../../../../vendors/pipe/DataPipe";
import If from "../../../../../vendors/components/If";
import { Card } from "primereact/card";
import AnttButton from "../../../../../vendors/components/Button";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

interface Props {
  controller: EventoVisualizarController;
  codPropostaNorma?: string;
}

export default function DocumentosdoEvento({
  controller,
  codPropostaNorma,
}: Props) {
  const _controller = new DocumentosController();
  const [lista, setLista] = useState<any[]>([]);
  const groupedData = useMemo(() => agruparPorTema(lista), [lista]);

  useEffect(() => {
    if (controller.tab === "documentacao") {
      const fetchData = async () => {
        try {
          const anexos = await _controller.obterAnexoProposta(codPropostaNorma);
          setLista(anexos);
        } catch (error) {
          console.error("Erro ao buscar dados:", error);
          ToastService.showError("Falha ao carregar os dados.");
        }
      };

      fetchData();
    }
  }, [controller.tab, codPropostaNorma]);

  function agruparPorTema(anexos: any[]) {
    return anexos.reduce((acc, item) => {
      const tema = item.cdSeqTemaNavigation?.dsTema || "Sem tema";
      acc[tema] = acc[tema] || [];
      acc[tema].push(item);
      return acc;
    }, {} as Record<string, any[]>);
  }

  const actionsTemplate = useMemo(() => {
    const endList = lista?.length;
    return (rowData: any) => (
      <div style={{ display: "flex", gap: "4px" }}>
        <AnttButton
          onClick={() => {
            controller.downloadPropostaNorma(rowData);
          }}
          className="p-button-rounded p-button-rounded-info"
          faIcon={faDownload}
        />
      </div>
    );
  }, [_controller, lista?.length]);

  return (
    <>
      <If condition={controller.tab === "documentacao"}>
        <div className="evento-vis-card-tab">
          <Field col={12}>
            <div className="datatable-responsive">
              <If condition={!lista || lista.length === 0}>
                <h4 className="text-center">Nenhum anexo encontrado</h4>
              </If>
              <If condition={!!lista && lista.length > 0}>
                <div className="flex justify-content-end">
                  <AnttButton
                    label="Baixar todos"
                    onClick={() => controller.downloadTodosAnexos()}
                  />
                </div>
                <br />
                {Object.entries(groupedData).map(([tema, items]: any) => (
                  <div key={tema} style={{ marginBottom: "2rem" }}>
                    <h3 className="ml-2">{tema}</h3>
                    <Divider />
                    <DataTable value={items} responsiveLayout="scroll">
                      <Column
                        field="dtExibicaoArquivo"
                        header="Data exibição"
                        body={formatDate("dtExibicaoArquivo")}
                      />
                      <Column
                        field="cdSeqTipoArquivoNavigation.dsTipoArquivo"
                        header="Tipo de arquivos"
                      />
                      <Column field="noAnexo" header="Anexo" />
                      <Column header="Ações" body={actionsTemplate} />
                    </DataTable>
                  </div>
                ))}
              </If>
            </div>
          </Field>
        </div>
      </If>
    </>
  );
}
